/**
 * Copyright © 2019 2020 2021 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {IAccountModel} from "../../../../../types/platform/server";
import {Callback} from "../../../../../types/platform/universe";
import {Guests2Service} from "../guests2.service";
import {Router} from "@angular/router";

@Directive({
	selector: "[profile-button]",
})

export class ProfileButtonDirective {

	@Input() public account: any;
	@Output() public complete = new EventEmitter<any>();

	constructor(
		private accountService: Guests2Service,
		private router: Router,
	) {
	}

	/**
	 * @returns Promise
	 */
	protected async sha256(text: string): Promise<string> {
		const uint8 = new TextEncoder().encode(text)
		const digest = await crypto.subtle.digest('SHA-256', uint8)
		return Array.from(new Uint8Array(digest)).map(v => v.toString(16).padStart(2, '0')).join('');
	}

	/**
	 * @returns none
	 */
	protected HashValue(S: string, length: number, callback: Callback<string>): void {
		this.sha256(S).then((hash): void => {
			callback(null, hash.slice(0, length));
		}).catch((error): void => {
			callback(error, null);
		});
	}

	/**
	 * todo
	 */
	@HostListener("click", ["$event.target"])
	public onProfile(): void {
		const user = this.account;
		this.accountService.belongs(user.user_id, (eror: any, results: []) => {
			const promises: any[] = [];
			results.forEach((account: IAccountModel) => {
				promises.push(new Promise((resolve, reject) => {
					this.HashValue(account.username, 10, (error, username_hash) => {
						if (!error) {
							let param: any = [];
							switch (account.type) {
								case "studio":
									param = ["s", username_hash];
									break;
								default :
							}
							resolve(param);
						} else {
							reject({});
						}
					});
				}));
			});

			Promise.all(promises).then((results) => {
				const params: any = {};
				results.forEach((value) => {
					if (value.length !== 0) {
						params[value[0]] = value[1];
					}
				})

				params["i"] = user.user_id;

				this.router.navigate(['/profile'], {queryParams: params});
				this.complete.emit({});

			}).catch((error) => {

			});

		})
	}
}
